export default __webpack_public_path__ + "static/media/guy-salock.0d5319a4.png";